"use client";

/**
 * The site's own chrome (footer, phone tab bar, install and sign-in
 * prompts, cookie note, feedback cards): rendered everywhere except the
 * Telegram Mini App (/[locale]/tg), which runs inside Telegram's frame
 * with its own phone layout and Telegram's buttons.
 */
import { usePathname } from "next/navigation";
import { isMiniAppPath } from "@/lib/mini-app-paths";

export default function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (isMiniAppPath(pathname)) return null;
  return <>{children}</>;
}
